import React, {Component} from 'react';
import Const from 'constants';

export class BaseDashboard extends Component {
    getKeyPlayersQuantity() {
        const {rawLineups} = this.props;

        const keyPlayers = [];
        rawLineups.asArr().map((lineup) => {
            lineup.getDistilled(Const.LP_CS_PRIMARY_STACK_GROUP_PREFIX).map((item) => {
                !inArray(item, keyPlayers) && keyPlayers.push(item);
            });
            lineup.getDistilled(Const.LP_CS_UNIVERSAL_STACK_GROUP_PREFIX).map((item) => {
                !inArray(item, keyPlayers) && keyPlayers.push(item);
            });
        });

        return keyPlayers.length;
    }

    getLineupsQuantity() {
        const {rawLineups, filterLineupsByCorrelationStackCombinations} = this.props;

        return filterLineupsByCorrelationStackCombinations?.hasCheckedCombinations()
            ? filterLineupsByCorrelationStackCombinations.getLineupsQuantity()
            : rawLineups.getQuantity();
    }
}
